import { Fetch } from '.';

export const generateSchemaJson =
  (f: Fetch) =>
  async (payload: any): Promise<any> =>
    f.fetchJSON<any>(payload, '/generate-schema-json', 'POST');
